import { useContext } from "react";
import AppContext from "../contexts/AppContext";
import { FeedbackStructure } from "./use-feedback";

const useAppFeedback = (): FeedbackStructure => {
  const { feedback } = useContext(AppContext);
  return feedback!;
}

export default useAppFeedback;